import { Injectable } from '@angular/core';
import { TradeInstructionsComponent } from '@irb/irb-editors/edit-trading-instructions/trade-instructions/trade-instructions.component';
import {orderTypes} from "@irb/irb-editors/edit-trading-instructions/trade-instructions/trade-instructions.model";
@Injectable({
	providedIn: 'root',
  })
export class DestinationInstruction {
destinationInstruction(caseValue:any,parent:TradeInstructionsComponent) {
	const self = parent;
		/*
		 * IREBALUX-3484 & IREBALUX-3342
		 * Not Held Order Destinations and Available Order Types
		 */
		const orderTypeValue = self.orderTypeSelected?self.orderTypeSelected.id:null;
		self.orderTypeRemainsVarious = (self.actionType == "MultiEdit" && orderTypeValue === null);// dijit.byId("orderType").displayedValue;
		let notHeldDestination = self.notHeldDestinationSelected?self.notHeldDestinationSelected.id : null;
		notHeldDestination = (notHeldDestination == "VIRTU" || notHeldDestination == "CITADEL") ? "KNIGHT" : notHeldDestination;
		notHeldDestination = (caseValue == "Landing") ? "" : notHeldDestination;
		switch (notHeldDestination) {
		case "AOM_PRINTER":
			if(orderTypeValue != "MARKET"){
			self.destinationInstructionText = "The Order Type was updated to Market. Only Market orders can be sent to the Block Desk.";
			}
			break;
		case "KNIGHT":
			self.orderTypes = self.getFilteredArray(orderTypes, 'destType', "ARRIVAL" );
			//IREBALUX-3342
			if (self.actionType == "MultiEdit") { // sa - this is only accessible when Shr quantity > 3000
				if (self.orderTypeRemainsVarious && self.data.notHeldDistAlgor) {
					this.CKMsg(self);
				} else if (orderTypeValue != "MARKET" && orderTypeValue != "LIMIT" && !self.orderTypeRemainsVarious ) {
					this.CKMsg(self);
				} else {
					self.destinationInstructionText = '';
				}
			} else if (orderTypeValue != "MARKET" && orderTypeValue != "LIMIT") {
				this.CKMsg(self);
			} else {
				self.destinationInstructionText = '';
			}
			break;
		default:
			self.destinationInstructionText = '';
			break;
		};
	}
	CKMsg(self:TradeInstructionsComponent) {
		self.orderTypeSelected = null;
		self.destinationInstructionText = "The Order Type must be updated. Only Market and Limit order types can be sent to the Destination specified.";
	}
}
